import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private base = environment.apiUrl;

  constructor(private http: HttpClient) {}

  private headers(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    });
  }

  getSportsList()         { return this.http.get(`${this.base}/api/exchange/sports/sportsList`, { headers: this.headers() }); }
  getVirtualSportsList()  { return this.http.get(`${this.base}/api/exchange/sports/virtualSportsList`, { headers: this.headers() }); }
  getLotterySportsList()  { return this.http.get(`${this.base}/api/exchange/sports/lotterySportsList`, { headers: this.headers() }); }

  getExchangeTypeList()   { return this.http.get(`${this.base}/api/exchange/exchangeTypeList`, { headers: this.headers() }); }

  getRacingEventsList()   { return this.http.get(`${this.base}/api/exchange/events/racingEventsList`, { headers: this.headers() }); }
  searchEventList(q: string) { return this.http.get(`${this.base}/api/exchange/events/searchEventList?query=${q}`, { headers: this.headers() }); }

  getAllEventsList()            { return this.http.get(`${this.base}/api/exchange/market/matchodds/allEventsList`, { headers: this.headers() }); }
  getFancyMarketList(id: string)  { return this.http.get(`${this.base}/api/exchange/markets/fancyMarketList?eventId=${id}`, { headers: this.headers() }); }
  getBallByBallMarket(id: string) { return this.http.get(`${this.base}/api/exchange/markets/getBallByBallMarket?eventId=${id}`, { headers: this.headers() }); }
  getMarketsEventList(id: string) { return this.http.post(`${this.base}/api/exchange/markets/getMarketsEventList`, { eventId: id }, { headers: this.headers() }); }

  getCasinoMainList()          { return this.http.get(`${this.base}/api/exchange/navigations/casino/casinoMainList`, { headers: this.headers() }); }
  getCasinoTabList()           { return this.http.get(`${this.base}/api/exchange/navigations/casino/casinoTabList`, { headers: this.headers() }); }
  getCasinoTableList()         { return this.http.get(`${this.base}/api/exchange/navigations/casino/casinoTableList`, { headers: this.headers() }); }
  getCasinoEvents()            { return this.http.get(`${this.base}/api/exchange/navigations/casinoEvents`, { headers: this.headers() }); }
  getInternationalCasinoList() { return this.http.get(`${this.base}/api/exchange/navigations/internationalCasinoList`, { headers: this.headers() }); }
  getSpecialEvents()           { return this.http.get(`${this.base}/api/exchange/navigations/specialEvents`, { headers: this.headers() }); }

  getNews()                         { return this.http.get(`${this.base}/api/exchange/news/exchangeNews`, { headers: this.headers() }); }
  getMarketResults(id: string)      { return this.http.get(`${this.base}/api/exchange/results/getMarketEventResults?marketId=${id}`, { headers: this.headers() }); }
  getSportsRule(id: string)         { return this.http.get(`${this.base}/api/exchange/rules/getSportsRule?sportId=${id}`, { headers: this.headers() }); }
  getSliderList()                   { return this.http.post(`${this.base}/api/exchange/slider/sliderList`, {}, { headers: this.headers() }); }
  getThemeConfig()                  { return this.http.get(`${this.base}/api/exchange/theme/getThemeConfig`, { headers: this.headers() }); }
  getTipsPreviewList()              { return this.http.get(`${this.base}/api/exchange/tips/tipsPreviewList`, { headers: this.headers() }); }
  getStreaming(eventId: string)     { return this.http.get(`${this.base}/api/exchange/streaming/exchEventsStreaming?eventId=${eventId}`, { headers: this.headers() }); }

  // User & Auth
  userLogin(data: any)            { return this.http.post(`${this.base}/app/users/userLogin`, data, { headers: this.headers() }); }
  userBalance()                   { return this.http.post(`${this.base}/app/exchange/users/userBalance`, {}, { headers: this.headers() }); }
  
  // Betting
  placeBet(data: any)             { return this.http.post(`${this.base}/app/exchange/users/placebet`, data, { headers: this.headers() }); }
}
